import { CapoPlugin } from "E:/shuzilvtu/gvi-mall/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];